import { Button, MagellanPopup } from "components/atoms";
import { useFormikContext } from "formik";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { PiBroom, PiIdentificationCard } from "react-icons/pi";
import Popup from "reactjs-popup";
import { PopupActions } from "reactjs-popup/dist/types";
import { IChannelForm } from "services/channel/types/query";
import { BUTTON_VARIANT } from "types/components/button/button.interface";
import { IChildrenProp } from "types/components/components.interface";
import "./PopupImportPermissionsForm.scss";

interface IPopupChannelCreateFormProps extends IChildrenProp {
  trigger?: JSX.Element;
  onAdd?: (action: PopupActions) => void;
  clearPopupValues?: () => void;
  header: string;
  showButtons?: boolean;
  buttonText: string;
}

const PopupImportPermissionsForm = ({
  trigger,
  onAdd,
  clearPopupValues,
  children,
  header,
  showButtons = true,
  buttonText
}: IPopupChannelCreateFormProps) => {
  const { t } = useTranslation();

  const popupRef = useRef<PopupActions>(null);

  const { setFieldValue, values } = useFormikContext<IChannelForm>();

  const onAddClick = async () => {
    onAdd && popupRef.current && values && onAdd(popupRef.current);
  };

  const disabledClearValues = false;

  const disabledOnAdd = false;

  return (
    <Popup ref={popupRef} modal nested trigger={trigger}>
      <MagellanPopup>
        <MagellanPopup.Header className="justify-center w-80 mb-5">
          {t(header)}
        </MagellanPopup.Header>
        {children}
        {showButtons && (
          <MagellanPopup.BottomButtons>
            {clearPopupValues && (
              <Button
                type="button"
                isClear
                onlyIcon
                onClick={clearPopupValues}
                disabled={disabledClearValues}
              >
                <Button.Description description={t('button.clear')} />
                <Button.Icon icon={<PiBroom />} />
              </Button>
            )}
            <Button
              type="button"
              variant={BUTTON_VARIANT.submit}
              disabled={disabledOnAdd}
              onClick={onAddClick}
            >
              <Button.Text text={buttonText} />
              <Button.Icon icon={<PiIdentificationCard />} />
            </Button>
          </MagellanPopup.BottomButtons>
        )}
      </MagellanPopup>
    </Popup>
  );
};

export default PopupImportPermissionsForm;
